import { useState } from "react";
import { Service } from "./service";
import { Input } from 'antd'
import CustomAutoComplete from "../../../../../../../v2-components/Antd/AutoComplete";

const SearchProductMagistralPrepared = ({ onProductSelect }) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const handleSearch = async (value) => {
    setInputValue(value);

    if (value.length < 2) return;

    const data = await new Service().getProducts(value)



    const results = data.data.map((item) => ({
      value: item.name,
      label: (
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <img
            src={item.image_url}
            alt={item.name}
            style={{ width: 40, height: 40, borderRadius: 6 }}
          />
          <div>
            {item.name}
            <div style={{ fontSize: 12, color: "#666" }}>{item.laboratory}</div>
          </div>
        </div>
      ),
      item,
    }));

    setOptions(results);
  };

  const handleSelect = (_, option) => {
    onProductSelect(option.item);
    setInputValue("");
  };

  return (
    <>
      <p>Buscar producto por nombre</p>
      <CustomAutoComplete
        label={'Buscar producto por nombre'}
        style={{ width: "100%" }} //Llevar alto a 39px, se debe sobreescribir la clase de Antd
        options={options}
        value={inputValue}
        onSearch={handleSearch}
        onSelect={handleSelect}
        onChange={(val) => setInputValue(val)}
      >
        <Input placeholder="Búsqueda en productos..." />
      </CustomAutoComplete>

    </>
  );
};

export default SearchProductMagistralPrepared;
